import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useLocalePath } from '@/hooks/useLocalePath';
import { LanguageSwitcher } from './LanguageSwitcher';
import type { JSX } from 'react';

export function Footer(): JSX.Element {
  const { t } = useTranslation();
  const path = useLocalePath();

  const legal = [
    { slug: 'regulamin', label: t('legal.terms') },
    { slug: 'polityka-prywatnosci', label: t('legal.privacy') },
    { slug: 'prawo-odstapienia', label: t('legal.withdrawal') },
    { slug: 'dostawa-i-platnosc', label: t('legal.shippingInfo') },
  ];

  return (
    <footer className="mt-24 bg-[var(--color-ink)] text-[var(--color-ground)]">
      <div className="rz-shell grid gap-10 py-14 md:grid-cols-4">
        <div className="space-y-3">
          <p className="font-display text-lg font-semibold">{t('common.brand')}</p>
          <p className="text-xs text-[var(--color-muted-soft)] leading-relaxed max-w-56">{t('common.tagline')}</p>
        </div>

        <nav aria-label={t('legal.terms')} className="space-y-2">
          <p className="rz-eyebrow text-[var(--color-muted-soft)]">{t('legal.terms')}</p>
          <ul className="space-y-1.5">
            {legal.map((item) => (
              <li key={item.slug}>
                <Link to={path(`/strona/${item.slug}`)} className="inline-flex min-h-10 items-center text-xs hover:underline underline-offset-4">
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label={t('nav.catalog')} className="space-y-2">
          <p className="rz-eyebrow text-[var(--color-muted-soft)]">{t('nav.catalog')}</p>
          <ul className="space-y-1.5">
            <li><Link to={path('/tkaniny')} className="inline-flex min-h-10 items-center text-xs hover:underline underline-offset-4">{t('nav.fabrics')}</Link></li>
            <li><Link to={path('/szukaj')} className="inline-flex min-h-10 items-center text-xs hover:underline underline-offset-4">{t('common.search')}</Link></li>
            <li><Link to={path('/konto')} className="inline-flex min-h-10 items-center text-xs hover:underline underline-offset-4">{t('nav.myAccount')}</Link></li>
          </ul>
        </nav>

        <div className="space-y-3">
          <p className="rz-eyebrow text-[var(--color-muted-soft)]">{t('common.language')}</p>
          <LanguageSwitcher />
          <p className="text-2xs text-[var(--color-muted-soft)] leading-relaxed pt-2">
            {t('checkout.mockPaymentBanner')}
          </p>
        </div>
      </div>
    </footer>
  );
}
